export function initPopups() {
  $(
    '#entry-content a[href*=".jpg"],#entry-content a[href*=".webp"],  #entry-content a[href*=".jpeg"],  #entry-content a[href*=".png"],  #entry-content a[href*=".gif"],  a.popup-img ',
  ).each(function () {
    if ($(this).parents(".gallery").length === 0) {
      $(this).magnificPopup({
        type: "image",
        fixedContentPos: false,
        closeOnContentClick: true,
        tLoading: '<div id="loader2">Cargando...</div>',
        mainClass: "mfp-zoom-out",
        removalDelay: 500,
      });
    }
  });

  // Inicializador para la galería nativa de WordPress (si la usás)
  // 1. Inicialización súper segura delegada desde la sección superior
  $(".slider_footer .marquee-item-inner").each(function () {
    $(this).magnificPopup({
      tLoading: '<div id="loader2">Cargando...</div>',
      mainClass: "mfp-zoom-out",
      removalDelay: 500,
      fixedContentPos: false,
      // DELEGACIÓN DIRECTA: Buscamos cualquier enlace dentro de los slides,
      // pero ignoramos los duplicados clonados por Swiper para que no falle el contador
      delegate: "a",
      type: "image",
      gallery: {
        tCounter: "%curr% de %total%",
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
      },
    });
  });

  // 2. Por separado la galería por defecto si la seguís usando
  $(
    ".slider_actividad .marquee-list, .galeria-mobile .swiper-wrapper, .mosaico-container .mosaico",
  ).each(function () {
    $(this).magnificPopup({
      tLoading: '<div id="loader2">Cargando...</div>',
      mainClass: "mfp-zoom-out",
      removalDelay: 500,
      fixedContentPos: false,
      delegate: "a",
      type: "image",

      gallery: {
        tCounter: "%curr% de %total%",
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
      },
    });
  });

  /*
  // Show more button functionality
  $("#show-more").on("click", function () {
    $(".gallery-list .hidden").slideToggle();
    //$(this).hide(); // Hide the button after expanding
    if ($(this).text() === "Ver todas las fotos") {
      $(this).text("Ver menos");
    } else {
      $(this).text("Ver todas las fotos");
    }
    setTimeout(() => {
      //scroll.update();
      ScrollTrigger.refresh();
    }, 3600);
  });

  $(".gallery-list").magnificPopup({
    delegate: "a.popup-image, a.popup-video", // Selector para ambos tipos
    type: "image", // Tipo por defecto
    tLoading: '<div id="loader2">Cargando...</div>',
    mainClass: "mfp-zoom-out",
    removalDelay: 500,
    fixedContentPos: false,
    gallery: {
      tCounter: "%curr% de %total%",
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1],
    },
    callbacks: {
      elementParse: function (item) {
        // Detectar tipo de contenido dinámicamente
        const href = item.el.attr("href");
        const dataType = item.el.attr("data-type");

        if (
          dataType === "video" ||
          href.includes(".mp4") ||
          href.includes(".mov") ||
          href.includes(".avi")
        ) {
          // Es un video
          item.type = "inline";
          item.src =
            '<div class="mfp-video-holder"><video controls autoplay style=""><source src="' +
            href +
            '" type="video/mp4">Tu navegador no soporta videos HTML5.</video></div>';
        } else {
          // Es una imagen
          item.type = "image";
        }
      },
      beforeOpen: function () {
        // Pausar todos los videos cuando se abra el popup
        $("video").each(function () {
          this.pause();
        });
      },
      close: function () {
        // Pausar video al cerrar popup
        $(".mfp-video-holder video").each(function () {
          this.pause();
        });
      },
    },
  });*/
}
